import { useContext, useEffect, useState } from "react";
import "./rewardsSettings.styles.scss";
import { LoyaltyContext } from "../../../../contexts/loyalty.context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import {
  orderBasedInitial,
  visitBasedInitial,
  feedbackBasedInitial,
  handleOrderSubmit,
  handleChange,
} from "./rewardsSettings.utils";
const RewardsSettings = ({ changeFunction }) => {
  const {
    pointsLoyalty,
    setPointsLoyalty,
    order_based_rewards,
    setOrderBasedRewards,
  } = useContext(LoyaltyContext);
  const [orderFields, setOrderFields] = useState(orderBasedInitial);
  const { orderValue, reward } = orderFields;
  const [visitFields, setVisitFields] = useState(visitBasedInitial);
  const { rewardPerVisit } = visitFields;
  const [feedbackFields, setFeedbackFields] = useState(feedbackBasedInitial);
  const { rewardPerFeedback } = feedbackFields;

  useEffect(() => {
    if (pointsLoyalty["order_based_rewards"]) {
      setOrderBasedRewards(pointsLoyalty["order_based_rewards"]);
    }
  }, [pointsLoyalty]);

  return (
    <div className="rewards-settings-container">
      {Object.keys(pointsLoyalty).length === 0 ? (
        <div className="rs-noloyalty-container">
          <span className="rs-noloyalty-message">
            You haven't created your loyalty points yet.{" "}
          </span>
          <span
            className="rs-noloyalty-button"
            onClick={() => changeFunction("points")}
          >
            &nbsp;Go to point settings&nbsp;
          </span>
        </div>
      ) : (
        <div className="rs-loyalty-container">
          <div className="rs-order-based">
            <div className="rs-ob-details">
              <span className="rs-ob-title">ORDER BASED REWARDS :</span>
              <span className="rs-ob-description">
                (Reward customers based on their order value.)
              </span>
            </div>
            <div className="rs-ob-add-box">
              <form
                onSubmit={(event) =>
                  handleOrderSubmit(
                    event,
                    setPointsLoyalty,
                    pointsLoyalty,
                    orderFields,
                    setOrderFields
                  )
                }
              >
                <input
                  type="text"
                  name="orderValue"
                  value={orderValue}
                  placeholder="Order Value"
                  onChange={(event) =>
                    handleChange(event, setOrderFields, orderFields)
                  }
                  className="rs-ob-input"
                />
                <input
                  type="number"
                  name="reward"
                  value={reward}
                  placeholder="Reward"
                  onChange={(event) =>
                    handleChange(event, setOrderFields, orderFields)
                  }
                  className="rs-ob-input"
                />
                <button type="submit" className="rs-ob-submit">
                  Add Reward
                </button>
              </form>
            </div>
            <div className="rs-ob-items">
              <span className="rs-ob-items-title">Rewards list :</span>
              {order_based_rewards &&
                Object.keys(order_based_rewards).map((index) => {
                  const tempObject = pointsLoyalty["order_based_rewards"];
                  const insideObject = tempObject[index];
                  return (
                    <div key={index} className="rs-ob-item">
                      <span className="rs-ob-itemvalue">
                        <span className="rs-ob-tag">Order Value : </span>
                        {insideObject["orderValue"]}
                      </span>
                      <span className="rs-ob-itemreward">
                        <span className="rs-ob-tag">Reward : </span>
                        {insideObject["reward"]}
                      </span>
                      <span className="rs-ob-itemdelete">
                        <FontAwesomeIcon icon={faTrash} />
                      </span>
                    </div>
                  );
                })}
            </div>
          </div>
          <div className="rs-visit-based">
            <div className="rs-vb-details">
              <span className="rs-vb-title">VISIT BASED REWARDS :</span>
              <span className="rs-vb-description">
                (Reward returning customers based on their visits.)
              </span>
            </div>
            <div className="rs-vb-add-box">
              <label className="rs-vb-label">REWARDS PER VISIT : </label>
              <input
                type="number"
                name="rewardPerVisit"
                value={rewardPerVisit}
                onChange={(event) =>
                  handleChange(event, setVisitFields, visitFields)
                }
                className="rs-vb-input"
              />
              <span className="rs-vb-add">Update rewards</span>
            </div>
          </div>
          <div className="rs-feedback-based">
            <div className="rs-fb-details">
              <span className="rs-fb-title">FEEDBACK BASED REWARDS :</span>
              <span className="rs-fb-description">
                (Reward customers for their feedback.)
              </span>
            </div>
            <div className="rs-fb-add-box">
              <label className="rs-fb-label">REWARDS PER FEEDBACK : </label>
              <input
                type="number"
                name="rewardPerFeedback"
                value={rewardPerFeedback}
                onChange={(event) =>
                  handleChange(event, setFeedbackFields, feedbackFields)
                }
                className="rs-fb-input"
              />
              <span className="rs-fb-add">Update rewards</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default RewardsSettings;
